import { WSTable, WSTableCell } from "@wingspanhq/fe-component-library";
import { IRateValue } from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import React, { useMemo } from "react";
import { RateCardTableProps } from "../../utils/types";
import { convertToTableData } from "../../utils/formatRateCardData";

export const RateCardTable: React.FC<RateCardTableProps> = ({
  values,
  customValueKeys = [],
  collapsed = false,
  loading = false
}) => {
  const tableData = useMemo(() => {
    const data = convertToTableData(values);
    return collapsed ? data.slice(0, 5) : data;
  }, [values, collapsed]);

  return (
    <WSTable<IRateValue>
      loading={loading}
      tableData={tableData}
      columns={[
        {
          config: {
            gridTemplateSizeMin: "0",
            gridTemplateSizeMax: "1.5fr",
            header: { text: "Rate" }
          },
          renderFunction: ({ data }) => (
            <WSTableCell text={data.description || data.name} />
          )
        },
        {
          config: {
            gridTemplateSizeMin: "0",
            gridTemplateSizeMax: "1fr",
            header: { text: "Value" }
          },
          renderFunction: ({ data }) => {
            const isCustom = customValueKeys.includes(data.key);
            return (
              <WSTableCell
                text={formatMoney(data.value, Currency.USD)}
                secondaryText={isCustom ? "Custom rate" : undefined}
              />
            );
          }
        }
      ]}
    />
  );
};
